import { c as _c } from "react/compiler-runtime";
import TrailerThumbnailItem from '@/app/[locale]/(worlds)/[roomId]/components/TrailerThumbnailItem';
import ViverseSkeleton from '@/components/ViverseSkeleton';
import { useTrailerViewMediaContext } from '@/context/TrailerViewMediaContext';
import { useUAContext } from '@/context/UAContext';
import useScrollFade from '@/hooks/useScrollFade';
import useThumbnailScroll from '@/hooks/useThumbnailScroll';
import { useCallback, useEffect, useRef, useState } from 'react';
const GAP = 12;
const CARD_WIDTH_M = 142;
const CARD_WIDTH_S = 100;
const TrailerThumbnails = () => {
  const $ = _c(44);
  const {
    isMobileLandscape
  } = useUAContext();
  const {
    mediaList,
    currentIndex,
    setCurrentIndex,
    isEmpty
  } = useTrailerViewMediaContext();
  const [container, setContainer] = useState(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const thumbnailRef = useRef(t0);
  const lastHandledIndexRef = useRef(null);
  const {
    canScrollLeft,
    canScrollRight,
    updateScrollFade
  } = useScrollFade(container);
  const [fullWidth, setFullWidth] = useState(0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [imgErrorArr, setImgErrorArr] = useState(t1);
  const scrollToThumbnail = useThumbnailScroll(container, thumbnailRef);
  const [thumbWidth, setThumbWidth] = useState(CARD_WIDTH_M);
  let t2;
  if ($[2] !== fullWidth || $[3] !== mediaList || $[4] !== scrollToThumbnail || $[5] !== setCurrentIndex) {
    t2 = index => {
      scrollToThumbnail(index, fullWidth, mediaList, setCurrentIndex);
    };
    $[2] = fullWidth;
    $[3] = mediaList;
    $[4] = scrollToThumbnail;
    $[5] = setCurrentIndex;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleClick = t2;
  let t3;
  let t4;
  if ($[7] !== mediaList.length) {
    t3 = () => {
      setImgErrorArr(Array(mediaList.length).fill(false));
    };
    t4 = [mediaList.length];
    $[7] = mediaList.length;
    $[8] = t3;
    $[9] = t4;
  } else {
    t3 = $[8];
    t4 = $[9];
  }
  useEffect(t3, t4);
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = idx => {
      setImgErrorArr(prev => {
        const next = [...prev];
        next[idx] = true;
        return next;
      });
    };
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const handleImgError = t5;
  const getVisibleThumbnail = _temp;
  let t6;
  if ($[11] !== container?.clientWidth || $[12] !== isMobileLandscape || $[13] !== updateScrollFade) {
    t6 = () => {
      const screenWidth = window.innerWidth;
      let _thumbWidth;
      if (screenWidth >= 1440) {
        _thumbWidth = CARD_WIDTH_M;
      } else {
        if (screenWidth === 1024 || screenWidth === 768) {
          _thumbWidth = CARD_WIDTH_S;
        } else {
          if (screenWidth < 768 || isMobileLandscape) {
            _thumbWidth = getVisibleThumbnail(3.5, GAP, container?.clientWidth || 390);
          } else {
            _thumbWidth = getVisibleThumbnail(6.5, GAP, container?.clientWidth || 768);
          }
        }
      }
      setThumbWidth(_thumbWidth);
      setFullWidth(_thumbWidth + GAP);
      updateScrollFade();
    };
    $[11] = container?.clientWidth;
    $[12] = isMobileLandscape;
    $[13] = updateScrollFade;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const updateThumbnailWidth = t6;
  let t7;
  let t8;
  if ($[15] !== container || $[16] !== updateThumbnailWidth) {
    t7 = () => {
      if (!container) {
        return;
      }
      const resizeObserver = new ResizeObserver(() => updateThumbnailWidth());
      resizeObserver.observe(container);
      updateThumbnailWidth();
      return () => resizeObserver.disconnect();
    };
    t8 = [container, updateThumbnailWidth];
    $[15] = container;
    $[16] = updateThumbnailWidth;
    $[17] = t7;
    $[18] = t8;
  } else {
    t7 = $[17];
    t8 = $[18];
  }
  useEffect(t7, t8);
  let t9;
  if ($[19] !== updateThumbnailWidth) {
    t9 = () => {
      updateThumbnailWidth();
    };
    $[19] = updateThumbnailWidth;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== isMobileLandscape || $[22] !== updateThumbnailWidth) {
    t10 = [isMobileLandscape, updateThumbnailWidth];
    $[21] = isMobileLandscape;
    $[22] = updateThumbnailWidth;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  useEffect(t9, t10);
  let t11;
  let t12;
  if ($[24] !== container) {
    t11 = () => {
      const el = container;
      if (!el) {
        return;
      }
      const onWheel = e => {
        if (e.deltaY === 0) {
          return;
        }
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
          return;
        }
        el.scrollLeft = el.scrollLeft + e.deltaY;
        e.preventDefault();
      };
      el.addEventListener("wheel", onWheel, {
        passive: false
      });
      return () => el.removeEventListener("wheel", onWheel);
    };
    t12 = [container];
    $[24] = container;
    $[25] = t11;
    $[26] = t12;
  } else {
    t11 = $[25];
    t12 = $[26];
  }
  useEffect(t11, t12);
  let t13;
  let t14;
  if ($[27] !== container || $[28] !== currentIndex || $[29] !== handleClick || $[30] !== isEmpty) {
    t13 = () => {
      if (!isEmpty && container && thumbnailRef.current[currentIndex]) {
        if (lastHandledIndexRef.current !== currentIndex) {
          handleClick(currentIndex);
          lastHandledIndexRef.current = currentIndex;
        }
      }
    };
    t14 = [isEmpty, container, currentIndex, handleClick];
    $[27] = container;
    $[28] = currentIndex;
    $[29] = handleClick;
    $[30] = isEmpty;
    $[31] = t13;
    $[32] = t14;
  } else {
    t13 = $[31];
    t14 = $[32];
  }
  useEffect(t13, t14);
  let t15;
  if ($[33] !== canScrollLeft || $[34] !== canScrollRight || $[35] !== currentIndex || $[36] !== handleClick || $[37] !== imgErrorArr || $[38] !== mediaList || $[39] !== thumbWidth || $[40] !== updateScrollFade) {
    t15 = mediaList.length > 0 && <div className="relative w-full overflow-visible"><div ref={setContainer} className="no-scrollbar scrollbar-hide flex w-full max-w-full min-w-0 flex-row gap-3 overflow-x-auto pt-3 md:pt-4" style={{
        scrollBehavior: "smooth"
      }}>{mediaList.map((item, index_0) => item.isPlaceholder ? <ViverseSkeleton key={item.key || `placeholder-${index_0}`} className="relative aspect-[16/9] min-w-[100px] flex-shrink-0 overflow-hidden rounded-lg" style={{
          width: thumbWidth
        }} /> : <TrailerThumbnailItem key={item.key || `thumbnail-${index_0}`} item={item} index={index_0} currentIndex={currentIndex} thumbWidth={thumbWidth} handleClick={handleClick} thumbnailRef={thumbnailRef} updateScrollFade={updateScrollFade} imgErrorArr={imgErrorArr} handleImgError={handleImgError} />)}</div>{canScrollLeft && <div className="z-floating pointer-events-none absolute top-0 bottom-0 left-0 w-[calc(var(--thumbnail-width,142px)*2/3)] -translate-x-3 bg-gradient-to-r from-[#121216] to-transparent" />}{canScrollRight && <div className="z-floating pointer-events-none absolute top-0 right-0 bottom-0 w-[calc(var(--thumbnail-width,142px)*2/3)] translate-x-3 bg-gradient-to-l from-[#121216] to-transparent" />}</div>;
    $[33] = canScrollLeft;
    $[34] = canScrollRight;
    $[35] = currentIndex;
    $[36] = handleClick;
    $[37] = imgErrorArr;
    $[38] = mediaList;
    $[39] = thumbWidth;
    $[40] = updateScrollFade;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  let t16;
  if ($[42] !== t15) {
    t16 = <>{t15}</>;
    $[42] = t15;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  return t16;
};
export default TrailerThumbnails;
function _temp(visibleCount, gap, containerWidth) {
  const thumbWidth_0 = (containerWidth - gap * (visibleCount - 1)) / visibleCount;
  return thumbWidth_0;
}